// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module--container--vl-Gb","title":"styles-module--title--2mi_I","text":"styles-module--text--2N8Su","video":"styles-module--video--1wZP5"};